// simple validation function just checks to see if the saved configs matches the default configs.  If not, then it uses the default configs.
export function checkStructure(inputObj: any, checkObj: any, checkPath: string) {
    if (typeof checkObj === "string")
        return true;

    if (Array.isArray(checkObj)) {
        console.log(`is array:`, checkObj)
        return true;
    }

    for (var key of Object.keys(checkObj)) {
        // console.log(`Checking: ${checkPath} for ${key}`)
        
        if (!Object.keys(inputObj).includes(key)) {
            console.log(`${checkPath} object does not have key ${key}`)
            return false;
        }


        if (Object.keys(checkObj[key]).length > 0) {
            if (!checkStructure(inputObj[key], checkObj[key], `${checkPath}.${key}`))
                return false;
        }
    }
    return true;
}